module.exports = __webpack_public_path__ + "static/media/androidim.c9583875.png";